import createUrlPattern from "./createUrlPattern"
import checkUrlAgainstPattern from "./checkUrlAgainstPattern"

interface Thread {
	// TODO
	_id: string
	y: number
	location: {
		host: string
		path: string
		selector: string
		percentFromTop: number
	}
}

export default function positionCommentY(
	thread: Thread,
	type: "preview" | "thread",
) {
	// first check if this is the right page for a thread
	const { host, pathPatternArray } = createUrlPattern(
		window.location.host,
		window.location.pathname,
	)
	const correctPageToDisplayThreadOn = checkUrlAgainstPattern(
		{ host, pathPatternArray },
		{
			host: thread.location.host,
			pathPatternArray: JSON.parse(thread.location.path),
		},
	)

	// then find the element the comment was left on and put the comment in the right place for that selector
	const element = document.querySelector(thread.location.selector)

	// if no such element on the page, do not display the comment
	// and if comment is made on document.body, do not display the comment
	if (!element || !correctPageToDisplayThreadOn) {
		return -1000
	} else {
		const rect = element.getBoundingClientRect()

		let newY =
			rect.y + window.scrollY + thread.location.percentFromTop * rect.height

		// now make sure it doesn't go off the screen
		let coords: DOMRect

		if (type == "preview") {
			coords = (document.querySelector(
				`#jam--preview-thread-${thread._id}`,
			) as Element).getBoundingClientRect()
		} else if (type == "thread") {
			coords = document.querySelector(`#jam--thread-container-${thread._id}`)
				? (document.querySelector(
						`#jam--thread-container-${thread._id}`,
				  ) as Element).getBoundingClientRect()
				: (document.querySelector(
						`#jam--preview-thread-${thread._id}`,
				  ) as Element).getBoundingClientRect()
		} else {
			// TODO
			throw new Error("TODO")
		}

		// you need to get the maximum height https://stackoverflow.com/questions/1145850/how-to-get-height-of-entire-document-with-javascript
		const body = document.body
		const html = document.documentElement
		const height = Math.max(
			body.scrollHeight,
			body.offsetHeight,
			html.clientHeight,
			html.scrollHeight,
			html.offsetHeight,
		)

		if (height < thread.y + coords.height) {
			const amountToMoveUp = thread.y + coords.height - height
			newY = thread.y - amountToMoveUp - 5
		}

		if (newY < 5 || thread.y < 5) {
			newY = 5
		}

		return newY
	}
}
